module.exports = __webpack_public_path__ + "static/media/Slice5@2x.1239008d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice5@2x.png
// module id = 1410
// module chunks = 0